// class-component-hooks.js
import Component from '@fwk-node-modules/vue-class-component';

// Register the router hooks with their names
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
  'setup' // for composition API
])